import * as React from "react";
import Popup from 'reactjs-popup';
import {IExtraInformationComponent} from "src/ScrollyInterface";
import InformationIcon_black from "../../assets/Icons/Black/InformationButton.png";
import InformationIcon_white from "../../assets/Icons/White/InformationButton.png";
import {setStyles} from "../../shared/breakpoints";
import "./ExtraInformation.scss";


const ExtraInformation = (props: IExtraInformationComponent) => {
	const {
		position,
		breakpoint,
		color,
		text
	} = props;

	const informationIconImage = color === "black" ? InformationIcon_black : InformationIcon_white;
	const positionButton = setStyles({ ...position }, breakpoint);

	const [open, setOpen] = React.useState(false);
	const closeModal = () => setOpen(false);
	const openModal = () => setOpen(true)

	return (
		<div>
			<a style={positionButton} className="InformationIcon" onClick={openModal}>
				<img src={informationIconImage}/>
			</a>
			<Popup open={open} closeOnDocumentClick={true} onClose={closeModal} modal={true}>
				<div className="modal">
					<button className="close" onClick={closeModal}>
						&times;
					</button>
					<div className="content">
						{text}
					</div>
				</div>
			</Popup>
		</div>
	);
};

export default ExtraInformation;



// WEBPACK FOOTER //
// ./src/components/ExtraInformation/ExtraInformation.tsx